// extracted by mini-css-extract-plugin
export default {"avatarWithFullname":"AvatarWithFullname_avatarWithFullname__njwuD","fullname":"AvatarWithFullname_fullname__MdjEC"};